import { createFileRoute } from "@tanstack/react-router";
import { ThemeProvider } from "@repo/mfe-core";
import SsoCreatePage from "../../../../pages/SsoSettings/components/SsoCreatePage";

export const Route = createFileRoute("/admin/settings/sso-settings/create")({
  component: () => (
    <ThemeProvider>
      <SsoCreatePage />
    </ThemeProvider>
  ),
});
